/* tslint:disable */

declare var Object: any;
export interface SFPollingInterface {
  "id"?: number;
}

export class SFPolling implements SFPollingInterface {
  "id": number;
  constructor(data?: SFPollingInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFPolling`.
   */
  public static getModelName() {
    return "SFPolling";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFPolling for dynamic purposes.
  **/
  public static factory(data: SFPollingInterface): SFPolling{
    return new SFPolling(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFPolling',
      plural: 'SFPolling',
      path: 'SFPolling',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFPolling.ts